import { Col, Flex, Grid, Row, Skeleton, Tabs, Typography } from "antd";
import SLDView from "../../../components/configuration/site/SLDView";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import AreaView from "../../../components/configuration/site/AreaView";
import { ArrowLeftOutlined } from "@ant-design/icons";
import SeuView from "../../../components/configuration/site/SeuView";
import DeviceView from "../../../components/configuration/device/DeviceView";
import TelegramView from "../../../components/configuration/site/TelegramView";
import DeviceAlarmView from "../../../components/configuration/device/DeviceAlarmView";

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

export default function ConfigurationSitePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [fetchWrapper] = useFetch();
  const screenSize = useBreakpoint();
  const [key, setKey] = useState(searchParams.get("Key") ?? "Area");
  let { siteID } = useParams();
  const [site, setSite] = useState(undefined);

  const tabItems = [
    {
      key: "Area",
      children: <AreaView siteID={siteID} />,
      label: <div className="font-lg">Area</div>,
    },
    {
      key: "SEU",
      children: <SeuView siteID={siteID}></SeuView>,
      label: <div className="font-lg">Significant Energy Usage</div>,
    },
    {
      key: "Device",
      children: <DeviceView siteID={siteID}></DeviceView>,
      label: <div className="font-lg">Device</div>,
    },
    {
      key: "Alarm",
      children: <DeviceAlarmView siteID={siteID}></DeviceAlarmView>,
      label: <div className="font-lg">Device Alarm</div>,
    },
    {
      key: "Telegram",
      children: <TelegramView siteID={siteID}></TelegramView>,
      label: <div className="font-lg">Telegram Group</div>,
    },
    {
      key: "SLD",
      children: <SLDView siteID={siteID}></SLDView>,
      label: <div className="font-lg">Single Line Diagram</div>,
    },
  ];

  function getSite() {
    fetchWrapper({
      endpoint_url: "site_management/getSiteByID",
      method: "GET",
      params: { SiteID: siteID },
      onSuccess: (value) => {
        setSite(value.site);
      },
      onResponseError: (error) => {
        setSite(false);
      },
    });
  }

  useEffect(() => {
    if (key != null) {
      setSearchParams({ Key: key }, true);
    }
  }, [key]);

  useEffect(() => {
    getSite();
  }, []);

  if (siteID == null) {
    return <>Invalid Site ID</>;
  }

  if (site == false) {
    return <>Failed to get site information</>;
  }

  return (
    <>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Title level={3} className="mt-2 mb-5 ml-5">
            <Flex align="center">
              <ArrowLeftOutlined
                className="mr-3"
                onClick={() => {
                  navigate("..?Key=Site");
                }}
              />
              {site == undefined ? (
                <Skeleton
                  active
                  className="mt-0 mb-0"
                  title={false}
                  paragraph={{ rows: 1, width: 200 }}
                ></Skeleton>
              ) : (
                <>Configure {site.Name}</>
              )}
            </Flex>
          </Title>
        </Col>
      </Row>
      <Row gutter={[12, 12]} style={{ height: "calc(100% - 60px)" }}>
        <Col span={24} style={{ height: "100%" }}>
          <Tabs
            tabPosition={
              screenSize["lg"] || screenSize["xl"] || screenSize["xl"]
                ? "left"
                : "top"
            }
            destroyInactiveTabPane
            items={tabItems}
            activeKey={key}
            onChange={(key) => {
              setKey(key);
            }}
            tabBarStyle={{ minWidth: "250px" }}
            style={{ height: "100%" }}
          ></Tabs>
        </Col>
      </Row>
    </>
  );
}
